import { QueryParser } from 'domains/common/queryParser';
import useTranslationAndTypograph from 'hooks/useTranslationAndTypograph';
import { logger } from 'logs';
import { useRouter } from 'next/router';
import React, { useEffect } from 'react';

import { CircularProgress } from 'components/basic/Loaders';
import LoaderChart from 'components/basic/Loaders/LoaderChart';
import { H1 } from 'components/basic/Typography';
import Page from 'components/layouts/Page';

import { useAppDispatch } from 'redux-store';
import getPaymentsStatus from 'redux-store/thunks/paymentsMethods/getPaymentsStatus';

import doFetch from 'utils/doFetch';

import s from './PaymentPendingPage.module.scss';

export default function PaymentPendingPage({
  isRu,
}: {
  isRu?: boolean;
}): JSX.Element {
  const t = useTranslationAndTypograph();
  const router = useRouter();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (!isRu || !router.query.id) {
      return;
    }

    async function fetchByInterval(): Promise<void> {
      try {
        logger.info({
          key: '[PaymentPendingPage][doFetch][getPaymentsStatus]',
          params: {
            id: router.query.id as string,
          },
          _msg: `[PaymentPendingPage][doFetch][getPaymentsStatus]`
        });
        const result = await dispatch(
          getPaymentsStatus(router.query.id as string),
        ).unwrap();

        const response = result[doFetch.responseSymbol];

        logger.info({
          key: '[PaymentPendingPage][doFetch][getPaymentsStatus][RESPONSE]',
          params: {
            result,
          },
          _msg: `[PaymentPendingPage][doFetch][getPaymentsStatus][RESPONSE][STATUS=${response.status}]`
        });

        const search = new QueryParser(window.location.search).set({
          token: router.query.token as string,
        });

        if (response.status === 202) {
          // @ts-ignore
          setTimeout(fetchByInterval, response.retry_in);
        } 
        else if (response.status === 200) {
          window.location.href = `/payments/new-payments/success/${search.toString()}`;
        } 
        else {
          window.location.href = `/payments/new-payments/fail/${search.toString()}`;
        }
      } catch (e) {
        setTimeout(fetchByInterval, 1000);
      }
    }

    fetchByInterval();
  }, []);

  return (
    <Page>
      <H1 className="text-center">{t('Processing your payment...')}</H1>
      {isRu ? (
        <div className={s.loaderRu}>
          <LoaderChart />
        </div>
      ) : (
        <>
          <div className={s.stepsWrapper}>
            <div className={s.step}>
              <div className={s.stepNumber}>1</div>
              <div className={s.text}>
                {t('Asked your bank to confirm the transaction')}
              </div>
            </div>
            <div className={s.step}>
              <div className={s.stepNumber}>2</div>
              <div className={s.text}>
                {t('Waiting for your payment to go through...')}
              </div>
            </div>
          </div>
          <CircularProgress className={s.loader} />
        </>
      )}
    </Page>
  );
}
